// extracted by mini-css-extract-plugin
export var contentBody = "_av-9";
export var headerImage = "_av-2";
export var imageButton = "_av-7";
export var imageButtonIcon = "_av-8";
export var imageHeader = "_av-4";
export var imageHeaderText = "_av-5";
export var imageOverlay = "_av-3";
export var imageTitle = "_av-6";
export var imageWrapper = "_av-1";
export var taskList = "_av-a";
export var widget = "_av-0";